import React, { useEffect, useRef, useState } from "react";
import {
  CogIcon,
  UserIcon,
  BuildingLibraryIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import Stepper from "../Common/Stepper";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import {
  DetailsApi,
  validateGstinPan,
  ValidatePhoneApi,
} from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";
import showNotification from "../../services/redux/NotifcationService";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import LogoDiv from "../Common/LogoDiv";
import logo from "../../img/BBPS_Horizontal.png";
import OTPModal from "./OTPModal";

export default function StepOne() {
  const [details, setDetails] = useState();
  const [gstin, setGstin] = useState("");
  const customerData = useSelector((state) => state.customerData.customerData);
  const [showLogo, setShowLogo] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const handleGstin = (e) => {
  //     setGstin(e.target.value)
  // }

  const gstinPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/;

  const handleGstin = (e) => {
    const value = e.target.value.toUpperCase();

    // Allow only alphanumerics and limit to 15 chars while typing
    if (/^[A-Z0-9]*$/.test(value) && value.length <= 15) {
      setGstin(value);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const inputRefs = useRef([]);

  const handleSubmitOTP = async (e) => {
    e.preventDefault();

    // Combine the OTP array into a single string
    const otpValue = otp.join("");

    // Validate OTP
    if (otpValue.length !== 6) {
      showNotification("Please enter a valid 6-digit OTP.", "error");
      return;
    }
    // console.log(userAgent)
    const Payload = {
      customerId: customerData.custId,
      otp: otp?.join(""),
      phone: details?.result.phone,
      isResend: false,
      isVerify: true,
    };
    //console.log(Payload);
    const data = await dispatch(
      ValidatePhoneApi(Payload, customerData?.token_chr, "customer"),
    );
    if (data?.result === "Phone number verified successfully.") {
      showNotification(data?.result, "success");
      getDetails();
      setIsPhoneValid(true);
      setIsModalOpen(false);
    }
    setOtp(["", "", "", "", "", ""]);
  };

  const handleResendOTP = async () => {
    setIsResendDisabled(true);
    // console.log(userAgent)
    const Payload = {
      customerId: customerData.custId,
      otp: otp?.join(""),
      phone: details?.result.phone,
      isResend: false,
      isVerify: false,
    };
    //console.log(Payload);
    const data = await dispatch(
      ValidatePhoneApi(Payload, customerData?.token_chr, "customer"),
    );
    if (data) {
      setIsModalOpen(true);
      showNotification("OTP Resent Successfully", "success");
      // Disable the resend button for 30 seconds
      setTimeout(() => setIsResendDisabled(false), 30000);
    }
  };

  // Handle input change for OTP
  const handleInputChange = (index, value) => {
    // Allow only digits
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to the next input field if a digit is entered
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    // Move focus to the previous input box on backspace
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const getDetails = async () => {
    // console.log(userAgent)
    const Payload = {
      id: customerData.custId,
    };
    // console.log(Payload)
    const data = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer"),
    );
    setDetails(data);
    setGstin(data?.result.gstin);
    setIsPhoneValid(data?.result.isPhoneVerified);
    setIsEmailValid(data?.result.isEmailVerified);
    dispatch(setDetailsData(data));
    if (data?.result?.programId === 34 || data?.result?.programId === 35) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };

  const validatePhone = async () => {
    // console.log(userAgent)
    const Payload = {
      customerId: customerData.custId,
      otp: otp?.join(""),
      phone: details?.result.phone,
      isResend: false,
      isVerify: false,
    };
    //console.log(Payload);
    const data = await dispatch(
      ValidatePhoneApi(Payload, customerData?.token_chr, "customer"),
    );
    if (data) {
      setIsModalOpen(true);
    }
  };

  const handleSubmit = async () => {
    // console.log(userAgent)
    const Payload = {
      gstin: gstin,
      customerId: customerData.custId,
      createdIp: "",
      createdUserAgent: "",
    };
    // console.log(Payload)
    try {
      if (gstin === "" || gstin === null) {
        showNotification("GSTIN is required", "error");
      } else if (gstin.length !== 15) {
        showNotification("GSTIN must be of 15 digits", "error");
      } else if (gstin.length === 15 && !gstinPattern.test(gstin)) {
        showNotification("Invalid GSTIN format", "error");
      } else {
        const data = await dispatch(
          validateGstinPan(Payload, customerData?.token_chr),
        );
        if (data) {
          setDetails(data);
          showNotification("Success", "success");
          dispatch(setDetailsData(data));
          navigate("/Customer/Step2");
        }
      }
    } catch (error) {
      showNotification(error, "error");
    }
  };
  return (
    <>
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          Contact Details
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo &&
                        {
                          /* <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width={"100px"} height={"100px"} />
                        </div> */
                        }}
                    </div>
                  </div>

                  <div className="py-2 text-center">
                    <h1 className="text-sm text-gray-600">
                      Please enter GSTIN of your organisation
                    </h1>
                  </div>
                  <div className="mt-2 border-none border-collapse rounded-md">
                    <table className=" w-full">
                      <tr className="border-b-2">
                        <td className="w-full sm:w-1/4 p-2" align="left">
                          <label className="font-semibold">
                            Merchant Name :{" "}
                          </label>
                        </td>
                        <td className="p-2 text-sm text-gray-800" align="left">
                          {details?.result.customerName}
                        </td>
                      </tr>
                      <tr className="border-b">
                        <td className="w-full sm:w-1/4 p-2" align="left">
                          <label className="font-semibold">Email : </label>
                        </td>
                        <td
                          className="p-2 text-sm text-gray-800 flex"
                          align="left"
                        >
                          <div
                            style={{ marginTop: "auto", marginBottom: "auto" }}
                          >
                            {" "}
                            {details?.result.email}
                          </div>
                          {isEmailValid && (
                            <CheckBadgeIcon
                              style={{
                                width: "30px",
                                height: "30px",
                                marginLeft: "10px",
                                marginTop: "auto",
                                marginBottom: "auto",
                                color: "green",
                              }}
                            />
                          )}
                        </td>
                      </tr>
                      <tr className="border-b">
                        <td className="w-full sm:w-1/4 p-2" align="left">
                          <label className="font-semibold">Phone : </label>
                        </td>
                        <td
                          className="p-2 text-sm text-gray-800 flex"
                          align="left"
                        >
                          <div
                            style={{ marginTop: "auto", marginBottom: "auto" }}
                          >
                            {details?.result.phone}
                          </div>
                          {!isPhoneValid ? (
                            <>
                              <button
                                onClick={() => validatePhone()}
                                style={{
                                  marginLeft: "10px",
                                  backgroundColor: "green",
                                  color: "white",
                                  padding: "6px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                Validate
                              </button>
                            </>
                          ) : (
                            <>
                              <CheckBadgeIcon
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  marginLeft: "10px",
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                  color: "green",
                                }}
                              />
                            </>
                          )}
                        </td>
                      </tr>
                    </table>
                    {/* {details?.result?.program === "HDFC Bharat Connect" && (
                      <div className="flex mt-2 ml-2">
                        <label
                          className="font-semibold"
                          style={{ marginTop: "auto", marginBottom: "auto" }}
                        >
                          Consent to add to Bharat Connect for business
                          ecosystem
                        </label>
                        <CheckBadgeIcon
                          style={{
                            width: "30px",
                            height: "30px",
                            marginLeft: "10px",
                            marginTop: "auto",
                            marginBottom: "auto",
                            color: "green",
                          }}
                        />
                      </div>
                    )} */}
                    <div className="py-4">
                      <label
                        for="email"
                        className="block text-md font-medium leading-6 text-gray-900"
                      >
                        GSTIN <span className="text-red-600">*</span>
                      </label>
                      <CustomerInput
                        onChange={handleGstin}
                        disabled={isPhoneValid === true ? false : true}
                        placeHolder="ENTER GSTIN"
                        inputStyles={{ padding: "12px" }}
                        value={gstin || ""}
                      />
                    </div>

                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                      <div className="relative text-center">
                        <button
                          disabled={isPhoneValid === true ? false : true}
                          onClick={handleSubmit}
                          style={{
                            cursor:
                              isPhoneValid === true ? "pointer" : "not-allowed",
                          }}
                          className="vtpRm-action-button"
                        >
                          {details?.result.gstin === "" ||
                          details?.result.gstin === undefined ||
                          details?.result.gstin === null
                            ? "Verify & Proceed"
                            : "Re-Verify & Proceed"}
                        </button>
                        {details?.result.lastCompletedStep > 1 ? (
                          <>
                            <span
                              className="skip-btn hover:cursor-pointer py-4 px-4"
                              onClick={() => navigate("/Customer/Step2")}
                            >
                              Skip this step
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
        {isModalOpen && (
          <OTPModal
            onClose={() => {
              setIsModalOpen(false);
              setOtp(["", "", "", "", "", ""]);
            }}
            otp={otp}
            setOtp={setOtp}
            isResendDisabled={isResendDisabled}
            setIsResendDisabled={setIsResendDisabled}
            inputRefs={inputRefs}
            handleSubmit={handleSubmitOTP}
            handleResendOTP={handleResendOTP}
            handleInputChange={handleInputChange}
            handleKeyDown={handleKeyDown}
          />
        )}
      </body>
    </>
  );
}
